import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { createConfig } from './BotpressProvider.utils';
import BotpressNotification from './components/BotpressNotification';
import Script from '../../../../components/Script';
import { BOTPRESS_GOOGLE_ANALYTICS_EVENT, BOTPRESS_LOADED_EVENT, BOTPRESS_WEBCHAT_CLOSED_EVENT, BOTPRESS_WEBCHAT_OPENED_EVENT } from '../../constants';
import useBotpress from '../../hooks/useBotpress';
import { isBotpressInitialized, isBotpressReady } from '../../services/checks';
import { generateBotpressNavigationWebEvent } from '../../services/eventGenerators';
import { getEventType, processGoogleAnalyticsEvent } from '../../services/eventProcessors';
import { BotpressConfigPropType } from '../../types/botpress';
var defaultProps = {
  botpressSrc: 'https://cdn.botpress.cloud/webchat/v2.2/inject.js'
};
export default function BotpressProvider(_ref) {
  var botpressSrc = _ref.botpressSrc,
    botpressConfig = _ref.botpressConfig,
    botId = _ref.botId,
    clientId = _ref.clientId,
    merchantId = _ref.merchantId;
  var _useBotpress = useBotpress(),
    showContainer = _useBotpress.showContainer,
    hideContainer = _useBotpress.hideContainer,
    sendEvent = _useBotpress.sendEvent;
  var location = useLocation();
  function handleBotpressEvent(event) {
    var _eventHandlerMap;
    var eventType = getEventType(event);
    var eventHandlerMap = (_eventHandlerMap = {}, _defineProperty(_eventHandlerMap, BOTPRESS_WEBCHAT_OPENED_EVENT, hideContainer), _defineProperty(_eventHandlerMap, BOTPRESS_WEBCHAT_CLOSED_EVENT, showContainer), _defineProperty(_eventHandlerMap, BOTPRESS_GOOGLE_ANALYTICS_EVENT, processGoogleAnalyticsEvent), _eventHandlerMap);
    var handler = eventHandlerMap[eventType];
    if (handler) {
      handler(event);
    }
  }
  function handleScriptLoad() {
    if (!isBotpressReady()) return;
    if (!isBotpressInitialized()) {
      window.botpress.init({
        botId: botId,
        configuration: createConfig(botpressConfig),
        clientId: clientId,
        user: {
          data: {
            merchantId: merchantId
          }
        }
      });
    }
    if (isBotpressInitialized()) {
      window.botpress.on('*', handleBotpressEvent);
      window.dispatchEvent(new Event(BOTPRESS_LOADED_EVENT));
    }
  }
  useEffect(function () {
    sendEvent(generateBotpressNavigationWebEvent(location));
  }, [location.pathname]);
  return /*#__PURE__*/React.createElement("div", {
    id: "botpress-provider"
  }, /*#__PURE__*/React.createElement(BotpressNotification, null), /*#__PURE__*/React.createElement(Script, {
    id: "botpress-script",
    src: botpressSrc,
    onLoad: handleScriptLoad,
    strategy: Script.STRATEGY_AFTER_USER_INTERACTION
  }));
}
BotpressProvider.defaultProps = defaultProps;